/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates
 */
export interface PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates {
    /**
     * 日付（YYYY-MM-DD）
     * @type {string}
     * @memberof PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates
     */
    date: string;
    /**
     * 該当の日付にある履歴の件数
     * @type {number}
     * @memberof PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates
     */
    itemCount: number;
}

export function PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDatesFromJSON(json: any): PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates {
    return PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDatesFromJSONTyped(json, false);
}

export function PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': json['date'],
        'itemCount': json['item_count'],
    };
}

export function PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDatesToJSON(value?: PrtimesMediaListsSelectedMediaListsLogOnlyDatesGetResponseAllOfDates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'item_count': value.itemCount,
    };
}

